import classNames from 'classnames';
import React, { ReactNode } from 'react';
import './entertainment-video-section.scss';

export function EntertainmentVideoSection({
  title,
  narrow,
  children
}: {
  title?: string,
  narrow?: boolean,
  children: ReactNode
}) {
  return (
    <div
      className={classNames(
        'entertainment-video-section',
        narrow && 'entertainment-video-section--narrow'
      )}
    >
      {title && (
        <div className="entertainment-video-section__heading">{title}</div>
      )}
      {children}
    </div>
  );
}
